import Auth from './Auth';

export default new Auth();
